import React, { useEffect, useState, useContext, useMemo } from 'react';
import OfficeWallets from '../components/OfficeWallets/OfficeWallets';
import OfficeRegisters from '../components/OfficeRegisters/OfficeRegisters';
import OfficeNews from '../components/OfficeNews/OfficeNews';
// import PeriodClosing from '../components/PeriodClosing/PeriodClosing';
import Skeleton from '../../../widgets/plug/Skeleton/Skeleton';
import { getNewsSkeleton, getUserNotification } from '../initData';
import UserModalInfo from '../../../widgets/userModalInfo/components/UserModalInfo/UserModalInfo';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import { getBreakpoint } from '../../../widgets/plug/Skeleton/components/patterns';
import css from './OfficeView.module.scss';
import UserContext, { UserProfileContext } from '../../../common/utils/getContext';
import UserInfo from '../components/UserInfo/UserInfo';
import SponsorInfo from '../components/SponsorInfo/SponsorInfo';
import classNames from 'classnames';
import OfficeVolumes from '../components/OfficeVolumes/OfficeVolumes';
import BranchDynamics from '../components/BranchDynamics/BranchDynamics';
import PartnerStats from '../components/PartnerStatsNew/PartnerStats';
import StructureDynamics from '../components/StructureDynamics/StructureDynamics';
import OfficeRank from '../components/OfficeRank/OfficeRank';
import OfficeActivity from '../components/OfficeActivityNew/OfficeActivity';
import EventsCalendar from '../components/EventsCalendar/EventsCalendar';
import InfoBlock from '../components/InfoBlock/InfoBlock';
import { getData } from '../../../common/utils/router';
import Bonuses from '../../../widgets/bonusesReceived/Bonuses';
import ConfirmPresence from '../components/ConfirmPresence/ConfirmPresence';
import Loader from '../../../widgets/plug/Loader/Loader';
import Notification from '../../../widgets/notification/Notification';
import T from '../../../common/components/T';
import Modal from '../../../widgets/modal/Modal';
import FormComponent from '../../../widgets/form/FormComponent/FormComponent';
import { API_SERVER_URL } from '../../../common/utils/utils';
// import { A, Img } from '../../../hybrid/wrappers';
// import topBanner from '../../../public/src/banner.png';
// import topBannerMob from '../../../public/src/banner_mob.png';
// import defaultCss from '../../../layouts/single/components/SingleHeader/single-header.module.scss';

const OfficeView = () => {
    const { profileData, loaded, roles } = useContext(UserProfileContext) || {};
    const { userToken, lang } = useContext(UserContext);
    const [verification, setVerification] = useState(null);
    const [activity, setActivity] = useState(null);
    const [minPricePackage, setMinPricePackage] = useState(null);

    const [sponsorModal, showSponsorModal] = useState(null);

    useEffect(() => {
        getData('/api/v1/shop/products?filter[type]=set&page[size]=0', userToken, lang).then((res) => {
            setMinPricePackage(+res?.['marketing_min_price']);
        });
    }, [userToken, lang]);

    useEffect(() => {
        getData('/api/v1/user/marketing/activity-progress', userToken, lang).then((res) => {
            if (res?.data) {
                setActivity(res);
            }
        });
    }, [userToken, lang]);

    useEffect(() => {
        getData('/api/v1/user/verification', userToken, lang).then(setVerification);
    }, [userToken, lang]);

    const [userData, setUserData] = useState('');

    const [showUser, setShowUser] = useState(false);

    useEffect(() => {
        window.dispatchEvent(new Event('resize'));
    }, []);

    const breakpoint = getBreakpoint(useWindowDimensions());

    const closeHandler = () => {
        setShowUser(false);
    };

    const notification = useMemo(() => {
        return getUserNotification(profileData, roles, minPricePackage, showSponsorModal);
    }, [profileData, roles, minPricePackage, showSponsorModal]);

    const isPartner = useMemo(() => {
        return Array.isArray(roles) && roles?.some((role) => ['partner'].includes(role.name));
    }, [roles]);

    if (!loaded) return <Loader />;
    return (
        <>
            {/* <div className={css.bannerWrap}>
                <A href={`/events/73?i=0`} className={css.topBanner}>
                    <Img quality={100} className={css.topBannerImg} src={topBanner} />
                </A>
                <A href={`/events/73?i=0`} className={defaultCss.topBannerMob}>
                    <Img quality={100} className={defaultCss.topBannerImg} src={topBannerMob} />
                </A>
            </div> */}
            <ConfirmPresence />
            {isPartner && Boolean(profileData?.marketing_profile?.activity) ? (
                <div className={css.wrapper}>
                    {showUser ? (
                        <UserModalInfo
                            showUser={showUser}
                            setShowUser={setShowUser}
                            userData={userData}
                            setUserData={setUserData}
                            closeHandler={closeHandler}
                        />
                    ) : null}
                    <InfoBlock activity={activity} verification={verification} />
                    <div className={classNames(css.grid, { [css.gridOne]: !profileData?.sponsor })}>
                        <UserInfo verification={verification} activity={activity} />
                        <SponsorInfo />
                    </div>
                    <EventsCalendar />
                    <div className={classNames(css.grid, css.walletsAndRewardsWrapper)}>
                        <Bonuses />
                        <OfficeWallets />
                    </div>
                    <OfficeVolumes />
                    <div className={classNames(css.grid, css.rowBranch)}>
                        <BranchDynamics />
                        <div className={classNames(css.column, css.columnRankActivity)}>
                            <OfficeRank />
                            <OfficeActivity activity={activity} />
                        </div>
                    </div>
                    <PartnerStats />
                    <StructureDynamics />
                    <OfficeRegisters setUserData={setUserData} showUser={showUser} />
                    <Skeleton
                        url={'/api/v1/news?page[size]=4'}
                        Component={OfficeNews}
                        itemsShiners={true}
                        componentProps={{}}
                        elements={getNewsSkeleton(breakpoint)}
                        lazy={true}
                        wrapperStyles={css.newsSkeleton}
                    />
                </div>
            ) : (
                <>
                    {profileData?.marketing_profile?.package && !profileData?.marketing_profile?.activity ? (
                        <>
                            <InfoBlock activity={activity} verification={verification} />
                            {/*    <Notification*/}
                            {/*    title={*/}
                            {/*        <T*/}
                            {/*            textName='to-access-to-office-alert-1'*/}
                            {/*            defaultStr='Для доступа в личный кабинет необходимо активировать учетную запись.'*/}
                            {/*            page='/office'*/}
                            {/*        />*/}
                            {/*    }*/}
                            {/*    icon='warning-rhombus'*/}
                            {/*    customCss={{ notification: css.notification, icon: css.notificationIcon }}*/}
                            {/*    buttonText={<T textName='go-store' defaultStr='Перейти в магазин' page='/office' />}*/}
                            {/*    buttonFunc={() => navigateV2('/store')}*/}
                            {/*/>*/}
                        </>
                    ) : notification ? (
                        <Notification
                            title={notification.title}
                            icon={notification.icon}
                            customCss={{ notification: css.notification, icon: css.notificationIcon }}
                            buttonText={notification.buttonText}
                            buttonFunc={notification.buttonFunc}
                        />
                    ) : null}

                    <div className={css.wrapper}>
                        <div className={isPartner && css.grid}>
                            <UserInfo verification={verification} activity={activity} />
                            {isPartner ? (
                                <OfficeActivity customCss={{ block: css.activityBlockFull }} activity={activity} />
                            ) : null}
                        </div>
                        <Skeleton
                            url={'/api/v1/news?page[size]=4'}
                            Component={OfficeNews}
                            itemsShiners={true}
                            componentProps={{}}
                            elements={getNewsSkeleton(breakpoint)}
                            lazy={true}
                            wrapperStyles={css.newsSkeleton}
                        />
                    </div>
                </>
            )}
            {sponsorModal ? (
                <Modal closeHandler={() => showSponsorModal(false)}>
                    <p className={css.sponsorModalTitle}>
                        <T textName='specify_a_recommender_id' defaultStr='Укажите ID рекомендателя' page='/office' />
                    </p>
                    <FormComponent
                        sendData={{
                            url: `${API_SERVER_URL}/api/v1/user/set-sponsor`,
                            afterSenderSuccess: () => {
                                window.location.reload();
                            }
                        }}
                        data={[
                            {
                                attribute: 'sponsor_username',
                                type: 'input',
                                title: {
                                    body: <T textName='recommender_id' defaultStr='ID рекомендателя' page='/office' />
                                }
                            }
                        ]}
                        buttons={[
                            {
                                type: 'ok',
                                buttonText: <T textName='confirm' defaultStr='Подтвердить' />
                            }
                        ]}
                        formStyles={{
                            sponsor_username: { wrapper: css.sponsorModalInput }
                        }}
                    />
                </Modal>
            ) : null}
        </>
    );
};
export default OfficeView;
